$('.productReviewStars').click(function() {
        var headerHeight = $("header").height();
        var position = $('.spr-container').offset().top;

        if ($("header").css("position") === "fixed") {
            var scrollPosition = position - headerHeight;
            $('html, body').animate({
                scrollTop: scrollPosition
            }, 'slow');
        } else {
            $('html, body').animate({
                scrollTop: position
            }, 'slow');
        }
    }
);

// FAQ Accordion

var acc = document.getElementsByClassName("faq-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  }); 
};


// Product page insert promotion on mobile

function insertPromoMobile () {
    if(document.getElementById('promoContentForMobile')) {
        $('#promoContentForMobile').clone().appendTo('#promoBoxMobile');
        document.getElementById('promoBoxContainer').style.display = 'block';
    }
 
}
insertPromoMobile ();




// Display/hide references

function referenceDisplay() {
    var references = document.getElementById("references");
    var referencesButton = document.getElementById("references-button");
    referencesButton.classList.toggle("references-open");
    if (references.style.display === "none") {
        references.style.display = "block";
    } else {
        references.style.display = "none";
    }
}



// About us animation


var $animation_elements = $('.animation-element');
var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);

  $.each($animation_elements, function() {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = (element_top_position + element_height);

    //check to see if this current container is within viewport
    if (!$element.hasClass("in-view")) {    
    if ((element_bottom_position >= window_top_position) &&
      (element_top_position <= window_bottom_position)) {
      setTimeout(inView, 50);
         function inView () { $element.addClass('in-view');
         }
      }
    }
  });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');


